<template>
  <div
    class="LKPublicationsCardHeader"
    :style="`cursor: ${actionless ? 'default' : 'pointer'};`"
    @click="actionless ? null : $emit('input', !value)"
  >
    <div class="LKPublicationsCardHeader__item">
      <div
        class="LKPublicationsCardHeader__date"
        v-text="formattedDate"
      />
    </div>

    <!--
    <div class="LKPublicationsCardHeader__item">
      <div
        class="LKPublicationsCardHeader__id"
        v-text="`# ${id}`"
      />
    </div>
    -->

    <div v-if="archived" class="LKPublicationsCardHeader__item">
      <div
        class="LKPublicationsCardHeader__archive"
        v-text="'В архиве'"
      />
    </div>

    <div class="LKPublicationsCardHeader__spacer" />

    <div
      class="LKPublicationsCardHeader__action"
      v-text="'Действия:'"
    />

    <div v-if="linkToEdit" class="LKPublicationsCardHeader__item">
      <router-link
        :to="linkToEdit"
        class="LKPublicationsCardHeader__link label__link"
        @click.native.stop
      >
        <v-tooltip top>
          <template #activator="{ attrs, on }">
            <div v-bind="attrs" v-on="on">
              <v-icon
                size="20px"
                v-text="'mdi-pencil'"
              />
            </div>
          </template>
          <div
            style="max-width: 200px;"
            v-text="'Перейти к редактированию публикации'"
          />
        </v-tooltip>
      </router-link>
    </div>

    <div v-if="!actionless" class="LKPublicationsCardHeader__item">
      <router-link
        :to="linkTo"
        class="LKPublicationsCardHeader__link"
        @click.native.stop
      >
        <IconLink
          borderless
          tooltip="Открыть публикацию в текущей вкладке"
          class="LKPublicationsCardHeader__link-icon"
        />
      </router-link>
    </div>

    <div v-if="authorized" class="LKPublicationsCardHeader__item" @click.stop>
      <v-tooltip top>
        <template #activator="{ attrs, on }">
          <div v-bind="attrs" v-on="on">
            <v-icon
              size="20px"
              :color="isStarred ? 'warning' : undefined"
              style="cursor: pointer;"
              @click="$emit('starred')"
              v-text="isStarred ? 'mdi-star' : 'mdi-star-outline'"
            />
          </div>
        </template>
        <div v-text="isStarred ? 'Убрать из избранного' : 'Добавить в избранное'" />
      </v-tooltip>
    </div>

    <div v-if="!actionless" class="LKPublicationsCardHeader__item">
      <IconToggle
        :active="value"
        :loading="loading"
        class="LKPublicationsCardHeader__link label__link"
      />
    </div>
  </div>
</template>

<script>
import { dateFormatterIgnoreTz } from '@/helpers/dateFormatter'
import { lkPublicationPermissions } from '@/helpers/enums/permission-models'
import { PUBLICATIONS_ROUTES } from '@/views/Publications/utils'
import { LK_PUBLICATIONS_ROUTES } from '@/views/LKPublications/utils'

import IconLink from '@/components/lk/icons/LKIconLink.vue'
import IconToggle from '@/components/lk/icons/LKIconToggle.vue'


const DATE_FORMAT = 'D MMM YYYY (dddd)'

export default {
  name: 'LKPublicationsCardHeader',
  components: {
    IconLink,
    IconToggle,
  },
  props: {
    loading: Boolean,
    archived: Boolean,
    actionless: Boolean,
    value: {
      type: Boolean,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
    slug: {
      type: String,
      required: true,
    },
    topicSlug: {
      type: String,
      default: '',
    },
    authorized: {
      type: Boolean,
      default: false,
    },
    isStarred: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    formattedDate() {
      return dateFormatterIgnoreTz(this.date, DATE_FORMAT)
    },
    linkTo() {
      return {
        name: LK_PUBLICATIONS_ROUTES.VIEW,
        params: {
          topic_slug: this.topicSlug || this.$route.params.topic_slug,
          slug: this.slug,
        },
      }
    },
    linkToEdit() {
      const hasAccess = this.$access(lkPublicationPermissions.edit)
      if (!hasAccess) return null

      const route = {
        name: PUBLICATIONS_ROUTES.EDIT,
        params: {
          id: this.id,
        },
      }

      return route
    },
  },
}
</script>

<style lang="scss">

@import "~@/assets/scss/components/Card/_BaseCardHeader.scss";

.LKPublicationsCardHeader {
  @include _BaseCardHeader;
}
</style>
